<button mat-stroked-button (click)="openDialog()">
  <div class="export-csv-button">
    <mat-icon>cloud_download</mat-icon>
    {{ 'PAYMENTS_EXPORT.EXPORT_BUTTON' | translate }}
  </div>
</button>
